import { IGetAllPesquisaSatisfacaoItemUseCase } from "../../../presentation/useCases/read/get_all_pesquisa_satisfacao_item_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { PesquisaSatisfacaoItemLista } from "../../models/pesquisa_satisfacao_item_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllPesquisaSatisfacaoItemUseCase
 */

export class GetAllPesquisaSatisfacaoItemUseCase
  extends BasePaginatedUseCase<PesquisaSatisfacaoItemLista>
  implements IGetAllPesquisaSatisfacaoItemUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async getAllPesquisaSatisfacaoItem(
    idPesquisaSatisfacao: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (!idPesquisaSatisfacao) throw new Error('idPesquisaSatisfacao é obrigatório');

    const result = await this.repository.getAllPesquisaSatisfacaoItem(
      idPesquisaSatisfacao,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
